<template>
  <div :class="['header', 'w3-display-container']">
    <span>{{ header.label }}</span>
    <div class="order-sort">
      <i :class="['fa', 'fa-caret-up', order]" @click="reorder($event, 'asc')"></i>
      <i :class="['fa', 'fa-caret-down', order]" @click="reorder($event, 'desc')"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'searcher-header',
  props: [
    'header'
  ],
  data () {
    return {
      order: null,
      id: null
    }
  },
  beforeMount () {
    this.order = this.header.order
    this.id = this.header.id
  },
  methods: {
    reorder (event, newOrder) {
      if (this.order === null) {
        this.order = newOrder
      } else if (this.order !== newOrder) {
        this.order = newOrder
      } else {
        this.order = null
      }
      this.$emit('refreshHeaderOrder', this.id, this.order)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .header {

    span {
      float: left;
    }

    .order-sort {
      float: left;
      margin-left: 10px;
      padding-top: 4px;

      i {
        color: #e4e4e4;
        cursor: pointer;
        font-size: 20px;
        position: relative;
        line-height: 1px;
      }
      i:hover {
        color: #ffbd42;
      }
    }
  }
  .header i.fa-caret-up.asc,
  .header i.fa-caret-down.desc {
    color: #ffbd42;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/header.vue